import { Icon, Link } from "@fluentui/react";
import { useNavigate } from "react-router-dom";

export function BackButton(): JSX.Element {
  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();

    navigate(-1);
  };

  return (
    <Link
      to="#"
      onClick={handleClick}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "4px",
        textDecoration: "none",
        width: "50px"
      }}
    >
      <Icon
        iconName="ChevronLeft"
        style={{
          fontSize: 8,
          fontWeight: 600,
          marginTop: 2
        }}
      />
      <span className={"ms-fontSize-12"}>{"Voltar"}</span>
    </Link>
  );
}
